module.exports = __webpack_public_path__ + "img/girl-winner.ce996621.png";